export default function (minHeight = 90, maxHeight = 200) {
    function autoExpandHeight(el) {
        const textarea = el as HTMLTextAreaElement

        function setHeight() {
            textarea.style.height = 'auto'
            textarea.style.height =
                Math.max(
                    minHeight,
                    Math.min(textarea.scrollHeight, maxHeight)
                ) + 'px'
        }

        textarea.oninput = setHeight
        setTimeout(setHeight, 0) // needed to defer call
    }

    return {
        mounted: autoExpandHeight,
    }
}
